import { Form, Input } from 'antd';
import moment from 'moment';
import { useEffect, useMemo } from 'react';

function Comments({ title, message, width, date, comment, status }: any) {
  const isEdit = status === 'Request' ? false : true;

  const defaultValue = useMemo(() => {
    return {
      message: message ? message : ''
    };
  }, [message]);
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(defaultValue);
  }, [form, defaultValue]);

  const warehouseCommentInput: React.ChangeEventHandler<HTMLTextAreaElement> = (
    e
  ) => {
    comment(e.target.value);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ width: `${width}`, height: '100%' }}
      initialValues={{
        message: defaultValue.message
      }}
    >
      <Form.Item>
        <div
          className="commentCard"
          style={{ marginBottom: '10px', height: '120px' }}
        >
          <div
            className="wrapTitle"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <p>{title}</p>
            <p style={{ color: '#A3A3A3' }}>{date}</p>
          </div>
          <Form.Item name="message">
            <Input.TextArea
              disabled={isEdit}
              style={{ resize: 'none' }}
              onChange={warehouseCommentInput}
            />
          </Form.Item>
        </div>
      </Form.Item>
    </Form>
  );
}

export default Comments;
